
const CreditApplicationProcessing = () => {
  return (
    <div className="flex justify-center items-center">
      <div className="relative w-[559px] bg-[#FFFFFF] h-full p-[22px] rounded-lg justify-center items-center">
        <div className="flex justify-center my-4">
          <Loader />
        </div>
        <p className="font-aeonik text-center text-2xl font-bold leading-7 my-2">
          Processing Loan Request
        </p>
        <p className="font-thin text-center text-[16px]">
          Please wait while your Loan request is being processed. This might take a few seconds to several minutes
        </p>
      </div>
    </div>
  )
}

const Loader = () => {
  return (
    <div className="relative w-[227px] h-2 bg-gray-300 overflow-hidden rounded">
      <div className="absolute left-2 top-0 h-full w-1/4 bg-[#00535C] animate-slide rounded"></div>
    </div>
  );
};

export default CreditApplicationProcessing;